import React, { useState } from "react";
import api from "../../services/api";
import { Modal, Col, Row, Form } from "react-bootstrap";
import IcX from "../../components/Svg/IcX";
import styleButton from "../Button/Button.module.css";
import styles from "./style.module.css";
import * as yup from "yup";
import { toast } from "react-toastify";
import { Password } from "../Input";
import useWrapper from "../../hooks/useWrapper";
import ModalCustom from "./modal-template-default";
import Button from "../Button";
import { validateForm, validateStyle } from "../../components/ValidateForm";

const ModalChangePass = props => {
  const { name, show, onHide, user_id, is_trainee, ...other } = props;

  const { me, config } = useWrapper();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [isWaitingResponse, setisWaitingResponse] = useState(false);

  const closeModal = () => {
    setPassword("");
    setConfirm("");
    onHide();
  }

  const updatePassword = async () => {
    const _is_valid = validateForm(document.getElementById("change_password"));
    if (!_is_valid) return;

    try {
      setisWaitingResponse(true);
      if (me?.type === "Formando")
        await api.put(`trainee/trainees/${me?.id}`, { password: password }, config);
      else if (me?.type === "Gestor" && !!is_trainee)
        await api.put(`trainees/${user_id}`, { password: password }, config);
      else if (me?.type === "Gestor")
        await api.put(`users/${user_id}`, { password: password }, config);
    } catch (__error) {
      console.log('__error', __error)
      toast.error("Erro ao tentar mudar a senha do usuário.");
    } finally {
      closeModal();
      toast.success("Senha modificada com sucesso.")
      setisWaitingResponse(false);
    }
  };

  return (
    <ModalCustom size="sm" show={show} onHide={closeModal} disableClose={isWaitingResponse} id="change_password">
      <ModalCustom.Header>
        <ModalCustom.Title>Alterar Senha</ModalCustom.Title>
      </ModalCustom.Header>
      <Modal.Body>
        <div>
          <p className="small-label">
            A nova senha deve ter no mínimo de 7 caracteres. Aconselhamos o uso de números, letras e caracteres
            especiais.
          </p>
        </div>
        <div className="mt-2">
          <span>Nova Senha</span>
          <Password
            required={true}
            value={password}
            autoComplete="off"
            has_error={!!password && password.length < 7}
            valueChange={__ev => {
              setPassword(__ev);
            }}
          />
        </div>
        <div className="mt-2">
          <span>Confirmar Senha</span>
          <Password
            required={true}
            value={confirm}
            autoComplete="off"
            has_error={password !== confirm || (!!confirm && confirm.length < 7)}
            valueChange={__ev => {
              setConfirm(__ev);
            }}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button disabled={!password || !confirm || isWaitingResponse} color="primary" onClick={updatePassword} >
          Alterar Senha
        </Button>
      </Modal.Footer>
    </ModalCustom>
  );
};

export default ModalChangePass;
